module.exports = __webpack_public_path__ + "static/media/apple.579645cb.svg";